import React from 'react'
import 'styled-components/macro'
import { styled } from 'styled-components'
import { QuestionWrapper } from '../../assets/styles'
import { _tempTheme } from '../../utils/tempTheme'

interface FooterStickyContainerProps {
	footerContent?: JSX.Element | boolean
	topContent: JSX.Element
	instantReview?: boolean
}

/**
 * This is a container for Student Questions.
 * It makes the footer sticky on the bottom when the question content is too big.
 * @param {JSX.Element | boolean} footerContent
 * @param { JSX.Element} topContent
 * @param {boolean} instantReview
 * @returns {JSX.Element}
 */
export const FooterStickyContainer = ({
	footerContent,
	topContent,
	instantReview,
}: FooterStickyContainerProps): JSX.Element => {
	return instantReview ? (
		<>
			{topContent}
			<div
				css={`
					padding-top: ${_tempTheme.spacing4};
				`}>
				{footerContent}
			</div>
		</>
	) : (
		<Wrapper>
			<div className="top-tile ">
				<div>
					{topContent}
					<br />
				</div>
			</div>

			<div className="bottom-tile">{footerContent}</div>
		</Wrapper>
	)
}

const Wrapper = styled(QuestionWrapper)`
	overflow: auto;
	height: 100%;
	width: 100%;
	display: flex;
	flex-direction: column;

	.bottom-tile {
		position: sticky;
		bottom: 0;
		height: ${({ theme }) => theme.spacingValue * 9}px;
		background-color: ${({ theme }) => theme.darkPrimary};
		z-index: 999;
	}

	.top-tile {
		position: relative;
	}
`

export default FooterStickyContainer
